import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {
  loginData=JSON.parse(localStorage.getItem('logindata'))
  constructor(public auth:AuthService) { }

  ngOnInit() {
  }
  fileChanged(event){
    if(event.target.files.length){
    this.auth.fileUpload(event.target.files[0]).subscribe(res=>{
    this.loginData.profilePicture = res['data']['thumb'] 
    },
  error=>{
alert('There was some error')
  })
  }
}
numberOnly(event,id): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }


}

}
